import getRandomNumber from "@/utils/getRandomNumber";

export default function getRandomPfp(postId: string = "") {
  const randomNumber = getRandomNumber(0, 5, postId ?? "");
  // return `/pfps/pfp${Math.abs(randomNumber)}.png`;
  return `/pfps/pfp6.png`;
}
